module.exports = __webpack_public_path__ + "static/media/interrogatGraySvg.9fbd2b08.svg";